export default function mutateToSelectOptions(optionObj) {
  return optionObj.map((opt) => ({ value: opt.id, label: opt.name }));
}
